import {
  F2100AdditionalBuildingType,
  InsuranceEvaluationType,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/AdditionalBuildings/additionalBuildingsInterfaces";
import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import {
  getCollectionOfDittoComponents,
  getComponentTextByFieldId,
  useTexts,
} from "Components/TextContext";

import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { HouseProduct } from "Store/interfaces/products/checkout/riskProducts/houseProducts/HouseProduct";
import React from "react";

interface Props {
  product: HouseProduct;
}
export const AdditionalBuildingsHouseDetails = ({
  product,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  const { house: houseProductTextComponents } = getCollectionOfDittoComponents(
    TextComponentNameLevel1.PRODUCTS,
  );

  return (
    <>
      {product.additionalBuildings.map((additionalBuilding, i) => {
        const id = `additionalhousetype-${additionalBuilding.type.toLowerCase()}`;

        const additionalHouseType = getComponentTextByFieldId(
          houseProductTextComponents,
          id,
        );
        const isCarport =
          additionalBuilding.type === F2100AdditionalBuildingType.CARPORT;

        const isGarageOuthouseAnnex =
          additionalBuilding.type ===
          F2100AdditionalBuildingType.GARAGE_OUTHOUSE_ANNEX;

        const isIsolated = additionalBuilding.isIsolated
          ? getText("houseform.shortvalue.hasisolation")
          : getText("houseform.shortvalue.hasnoisolation");

        const grossArea = (
          <NumberValue
            type={VALUE_TYPE.SQUARE_METERS}
            value={additionalBuilding.grossArea}
          />
        );
        const constructionYear = additionalBuilding.constructionYear;
        const firstRiskIsSet =
          additionalBuilding.insuranceEvaluationType ===
          InsuranceEvaluationType.FIRST_RISK;
        const insuranceEvaluationType = firstRiskIsSet
          ? `${getText(
              "additionalbuildings.insuranceevaluationtype.first_risk",
            )}, `
          : getText("additionalbuildings.insuranceevaluationtype.full_value");
        const firstRiskSum = firstRiskIsSet && (
          <NumberValue
            type={VALUE_TYPE.NOK}
            value={additionalBuilding?.firstRiskSum}
          />
        );

        return (
          <>
            <div key={`${product.productId}_${i}`}>
              {`${additionalHouseType}, `}
              {!isCarport && !isGarageOuthouseAnnex && `${isIsolated}, `}
              {grossArea}
              {`, ${constructionYear}`}
              {`, ${insuranceEvaluationType}`}
              {firstRiskSum}
            </div>
            <br />
          </>
        );
      })}
    </>
  );
};
